import React, { useState } from 'react';
import qs from 'qs';
import { locationT } from '@ordermentum/ui-types';
import axios from 'axios';
import { PasswordEntryForm } from './Forms/PasswordEntryForm';
import { LoginBase } from './LoginBase';
import { Header } from './DefaultLogin';
import { history } from '../../lib/history';
import { MFAAction } from './Forms/MFAForm';

export const DefaultPasswordResetEntry = (props: { location: locationT }) => {
  const queryStrings = qs.parse(props.location.search, {
    ignoreQueryPrefix: true,
  });
  const { password_reset_token: passwordResetToken } = queryStrings;

  const [error, setError] = useState<string | undefined>();

  const onSubmit = async (password: string) => {
    setError(undefined);
    const query = qs.stringify({
      _method: 'put',
      password_reset_token: passwordResetToken,
    });
    try {
      await axios.post(`/user/password?${query}`, {
        password,
      });
    } catch (e) {
      if (
        e?.isAxiosError &&
        e.response.status === 403 &&
        e.response.data.error === 'mfa_required'
      ) {
        const { method, state, target, userId } = e.response.data.data;
        history.push(
          `/mfa?method=${method}&state=${state}&target=${target}&userId=${userId}&action=${MFAAction.PASSWORD_RESET}&passwordResetToken=${passwordResetToken}`
        );
        return false;
      }
      setError(`Something went wrong submitting your password: ${e.message}`);
      return false;
    }

    window.location.href = '/';
    return true;
  };

  return (
    <LoginBase type="default" header={<Header />}>
      <PasswordEntryForm onSubmit={onSubmit} error={error} />
    </LoginBase>
  );
};
